<template>
  <div class="enpty">
    <svg-icon
      :icon-class="icon"
      :style="{ fontSize: size }"
    />
    <div
      class="tit"
      :style="{ fontSize: fsize, marginTop, color }"
    >
      {{ props.title }}
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    default: '暂无数据',
  },
  icon: {
    // 展示数量
    type: String,
    default: 'empty',
  },
  size: {
    type: String,
    default: '160px',
  },
  fsize: {
    type: String,
    default: '14px',
  },
  marginTop: {
    type: String,
    default: '14px',
  },
  color: {
    type: String,
    default: '#999',
  },
});
</script>
<style lang="scss">
.enpty {
  margin-top: 80px;
  margin: 80px auto 0;
  text-align: center;
  color: #999;
  .tit {
    font-size: 14px;
  }
}
</style>
